var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('b-button',{class:_vm.buttonClass,attrs:{"variant":"outline-secondary","size":"sm","disabled":_vm.disabled || _vm.isExecuting,"pill":""},on:{"click":_vm.executeDefer}},[(_vm.isExecuting)?_c('b-spinner',{attrs:{"small":""}}):_c('span',[_vm._v("보류")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }